import { shouldShowFolderPane, shouldShowFolderPaneAsOverlay } from 'owa-mail-layout';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function shouldShowCommandBarHamburgerButton(): boolean {
    return (
        isFeatureEnabled('tri-metaOsRail') &&
        (!shouldShowFolderPane() || shouldShowFolderPaneAsOverlay())
    );
}
